import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/ui/Modal';
import { FormattedMessage } from 'react-intl';
import { StyledColumn } from '../AfterSalesWarning.styles';
import { CancelButton } from 'components/ui/Button';
import { Row } from 'components/shared/Layout';
import { EUROSTAR_CARRIERS } from 'constants/serviceTypeCodes';
import { bookingShape } from 'constants/propTypes';

const CannotSellByItselfWarning = ({ isOpen, closeModal, booking }) => {
  const externalCarrierCode = [...(booking.outbound || []), ...(booking.inbound || [])].find(
    (leg) => !EUROSTAR_CARRIERS.includes(leg.serviceType?.code)
  )?.serviceType?.brandCode;

  return (
    <Modal
      isOpen={isOpen}
      title={<FormattedMessage id="searchResults.cannotBeBooked" />}
      subtitle={<FormattedMessage id={'aftersalesWarning.cannotLeaveOrphansExternalCarriers'} values={{ carrier: externalCarrierCode }} />}
      onClose={closeModal}
    >
      <Row>
        <StyledColumn span={3}>
          <CancelButton data-cy="cancel" onClick={closeModal}>
            <FormattedMessage id="manageBooking.cancel" />
          </CancelButton>
        </StyledColumn>
      </Row>
    </Modal>
  );
};

CannotSellByItselfWarning.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  booking: bookingShape
};

export default CannotSellByItselfWarning;
